<template>
  <a-modal
    title="提示"
    :visible="visible"
  >
    <p>您的总单量已使用完，请及时购买，以免影响系统正常使用！</p>
    <template #footer>
        <a-button type="primary" @click="handleOk">立即购买</a-button>
    </template>
  </a-modal>
</template>

<script>
import { IS_SELLERWELL } from '@/store/mutation-types'
import { mapGetters } from 'vuex'

export default {
  name: 'ErpEmptyModal',
  computed: {
    ...mapGetters([
      'systems',
      'systemCode'
    ])
  },
  data () {
    return {
      visible: false,
      disableClick: false
    }
  },
  methods: {
    hasPermission () {
       const { status, serviceBillingValueDTOList } = this.systems.find(item => item.systemCode === this.systemCode) || {}
       if (['ERP', 'AMAZON_OPERATE', 'BI'].includes(this.systemCode)) {
        const packageQuantity = (serviceBillingValueDTOList || [])?.find(item => item.keyValue === 'packageQuantity')
        const ERPPan = this.systemCode === 'ERP' && packageQuantity?.billingItemValue * 1 <= 0 && packageQuantity?.unlimitedUse !== 1

        if ((status === 4 || ERPPan) && IS_SELLERWELL) {
          this.disableClick = true
          this.visible = true
          return
        }
      }
      this.disableClick = false
      this.visible = false
    },
    handleOk () {
      const { params: { serviceId, systemCode } } = this.$route
      this.visible = false
      this.$store.dispatch('entry/SetActiveAsync', {
        ignore: true,
        path: `/entry/${serviceId}/${systemCode}/sso-web#/user/product-package`,
        menuName: {
          zh_CN: '产品套餐',
          en_US: 'Product Package',
          ko_KR: '상품 패키지'
        }
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
        this.hasPermission()
    })
  }
}
</script>

<style lang="less" scoped></style>
